import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    InputAdornment,
    TextField,
    Typography,
    useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";
import PercentIcon from "@mui/icons-material/Percent";
import { useTransaksiStore } from "../../stores/transaksiStore";
import toRupiah from "../../utils/toRupiah";

interface IModalDiskonProps {}

const ModalDiskon = (props: IModalDiskonProps) => {
    const theme = useTheme();
    const isPhoneScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const totalHarga = useTransaksiStore((s) => s.totalHarga);
    const aturDiskon = useTransaksiStore((s) => s.aturDiskon);
    const grandTotal = useTransaksiStore((s) => s.grandTotal);
    const diskon = useTransaksiStore((s) => s.diskon);
    const isOpenModalTransaksi = useTransaksiStore(
        (s) => s.isOpenModalTransaksi,
    );
    const closeModalTransaksi = useTransaksiStore(
        (s) => s.closeModalTransaksi,
    );

    return (
        <Dialog
            fullWidth
            fullScreen={isPhoneScreen}
            open={isOpenModalTransaksi}
            onClose={closeModalTransaksi}
        >
            <DialogTitle>Atur Diskon</DialogTitle>
            <DialogContent>
                <Box display="grid" gridTemplateRows="1fr 1fr 1fr">
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <Typography variant="h6">Harga Awal</Typography>
                        <Typography variant="h6">
                            {toRupiah(totalHarga)}
                        </Typography>
                    </Box>
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <Typography variant="h6">Set Diskon</Typography>
                        <TextField
                            placeholder="Diskon"
                            value={diskon}
                            size="small"
                            type="number"
                            onKeyDown={(evt) =>
                                ["e", "E", "+", "-"].includes(evt.key) &&
                                evt.preventDefault()
                            }
                            onChange={(
                                event: React.ChangeEvent<HTMLInputElement>,
                            ) => {
                                aturDiskon(
                                    Number(event.target.value),
                                    "nominal",
                                ); //hanya placeholder, tolong hiraukan
                            }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <PercentIcon />
                                    </InputAdornment>
                                ),
                                inputProps: {
                                    style: {
                                        width: "50px",
                                        textAlign: "center",
                                    },
                                },
                            }}
                        />
                    </Box>
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <Typography variant="h6">
                            Harga Setelah Diskon
                        </Typography>
                        <Typography variant="h6">
                            {toRupiah(grandTotal)}
                        </Typography>
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={closeModalTransaksi}>
                    Konfirmasi
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ModalDiskon;
